export enum LicenseLimitExceededReasons {
  MaxLiveDurationMs = "maxLiveDurationMs"
}
